import type { AppLocale } from '@/i18n/locales'
import type { BuffSpeechPreferences } from './speech-types'

export const MANBO_VOICE_ID = 'manbo:zh-CN:v1'
export const MANBO_CACHE_NAME = 'maple-log-manbo-v1'
export const MANBO_LOCK = 'maple-log:manbo-generation'
export const MANBO_FAILURE_SETTING = 'manboGenerationFailure'

export interface ManboClip {
  key: string
  text: string
  url?: string
  state: 'pending' | 'ready' | 'failed'
  error?: string
  usedAt: number
}

export function usesManbo(locale: AppLocale, preferences: BuffSpeechPreferences): boolean {
  return locale.startsWith('zh') && preferences.voices['zh-CN'] === MANBO_VOICE_ID
}

export function manboClipKey(text: string): string { return `${MANBO_VOICE_ID}:${text.trim()}` }

export function isManboAudioUrl(value: unknown): value is string {
  if (typeof value !== 'string') return false
  try {
    const url = new URL(value)
    return url.origin === 'https://media.milorapart.top' && !url.username && !url.password
      && /^\/voice\/[\w-]+\.mp3$/.test(url.pathname)
  } catch { return false }
}

